// mds-dojo — dijit/_editor/selection — FAITHFUL port of references/dijit/_editor/selection.js.
// Deprecated text-selection API used by the editor (will be removed in dojo 2.0).
//
// ADAPTATIONS for this package:
//  - `dojo/sniff` → dropped; `dojo/_base/window` kept as `win`; `dojo/dom` kept for dom.byId;
//    `../main` (dijit) import dropped — the internal `dijit._editor.selection.getType()`
//    self-references are rewritten to the local `selection.getType()` (identical object).
//  - BROWSER-FORK COLLAPSE: every method had a W3C branch (win.doc.getSelection) and a
//    legacy IE6-8 branch (win.doc.selection.*). Only the W3C branch is kept; the IE else
//    branches are dropped. The has("opera") special-cases in selectElementChildren /
//    selectElement are also dropped (evergreen: Opera's selectAllChildren works).
//  - lang.setObject("dijit._editor.selection", selection) back-compat registration is kept.
import dom from '../../dojo/dom'; // dom.byId
import lang from '../../dojo/_base/lang';
import win from '../../dojo/_base/window'; // win.body win.doc win.global

// module:
//		dijit/_editor/selection

var selection: any = {
	// summary:
	//		Deprecated text selection API.  Will be removed in 2.0.  New code should use dijit/selection.

	getType: function(){
		// summary:
		//		Get the selection type (like win.doc.select.type in IE).
		// W3C path
		var stype = "text";

		// Check if the actual selection is a CONTROL (IMG, TABLE, HR, etc...).
		var oSel;
		try{
			oSel = win.global.getSelection();
		}catch(e){ /*squelch*/ }

		if(oSel && oSel.rangeCount == 1){
			var oRange = oSel.getRangeAt(0);
			if(	(oRange.startContainer == oRange.endContainer) &&
				((oRange.endOffset - oRange.startOffset) == 1) &&
				(oRange.startContainer.nodeType != 3 /* text node*/)
			){
				stype = "control";
			}
		}
		return stype; //String
	},

	getSelectedText: function(){
		// summary:
		//		Return the text (no html tags) included in the current selection or null if no text is selected
		// W3C path
		var selection = win.global.getSelection();
		return selection ? selection.toString() : ""; //String
	},

	getSelectedHtml: function(){
		// summary:
		//		Return the html text of the current selection or null if unavailable
		// W3C path
		var selection = win.global.getSelection();
		if(selection && selection.rangeCount){
			var i;
			var html = "";
			for(i = 0; i < selection.rangeCount; i++){
				//Handle selections spanning ranges, such as Opera
				var frag = selection.getRangeAt(i).cloneContents();
				var div = win.doc.createElement("div");
				div.appendChild(frag);
				html += div.innerHTML;
			}
			return html; //String
		}
		return null;
	},

	getSelectedElement: function(){
		// summary:
		//		Retrieves the selected element (if any), just in the case that
		//		a single element (object like and image or a table) is
		//		selected.
		if(selection.getType() == "control"){
			// W3C path
			var sel = win.global.getSelection();
			return sel.anchorNode.childNodes[ sel.anchorOffset ];
		}
		return null;
	},

	getParentElement: function(){
		// summary:
		//		Get the parent element of the current selection
		if(selection.getType() == "control"){
			var p = this.getSelectedElement();
			if(p){ return p.parentNode; }
		}else{
			var sel = win.global.getSelection();
			if(sel){
				var node = sel.anchorNode;
				while(node && (node.nodeType != 1)){ // not an element
					node = node.parentNode;
				}
				return node;
			}
		}
		return null;
	},

	hasAncestorElement: function(/*String*/ tagName: any /* ... */){
		// summary:
		//		Check whether current selection has a  parent element which is
		//		of type tagName (or one of the other specified tagName)
		// tagName: String
		//		The tag name to determine if it has an ancestor of.
		return this.getAncestorElement.apply(this, arguments) != null; //Boolean
	},

	getAncestorElement: function(/*String*/ tagName: any /* ... */){
		// summary:
		//		Return the parent element of the current selection which is of
		//		type tagName (or one of the other specified tagName)
		// tagName: String
		//		The tag name to determine if it has an ancestor of.
		var node = this.getSelectedElement() || this.getParentElement();
		return this.getParentOfType(node, arguments); //DOMNode
	},

	isTag: function(/*DomNode*/ node: any, /*String[]*/ tags: any){
		// summary:
		//		Function to determine if a node is one of an array of tags.
		// node:
		//		The node to inspect.
		// tags:
		//		An array of tag name strings to check to see if the node matches.
		if(node && node.tagName){
			var _nlc = node.tagName.toLowerCase();
			for(var i=0; i<tags.length; i++){
				var _tlc = String(tags[i]).toLowerCase();
				if(_nlc == _tlc){
					return _tlc; // String
				}
			}
		}
		return "";
	},

	getParentOfType: function(/*DomNode*/ node: any, /*String[]*/ tags: any){
		// summary:
		//		Function to locate a parent node that matches one of a set of tags
		// node:
		//		The node to inspect.
		// tags:
		//		An array of tag name strings to check to see if the node matches.
		while(node){
			if(this.isTag(node, tags).length){
				return node; // DOMNode
			}
			node = node.parentNode;
		}
		return null;
	},

	collapse: function(/*Boolean*/ beginning: any){
		// summary:
		//		Function to collapse (clear), the current selection
		// beginning: Boolean
		//		Indicates whether to collapse the cursor to the beginning of the selection or end.
		// W3C path
		var selection = win.global.getSelection();
		if(selection.removeAllRanges){ // Mozilla
			if(beginning){
				selection.collapseToStart();
			}else{
				selection.collapseToEnd();
			}
		}else{ // Safari
			// pulled from WebCore/ecma/kjs_window.cpp, line 2536
			selection.collapse(beginning);
		}
	},

	remove: function(){
		// summary:
		//		Function to delete the currently selected content from the document.
		// W3C path
		var sel = win.global.getSelection();
		sel.deleteFromDocument();
		return sel; //Selection
	},

	selectElementChildren: function(/*DomNode*/ element: any, /*Boolean?*/ nochangefocus?: any){
		// summary:
		//		clear previous selection and select the content of the node
		//		(excluding the node itself)
		// element: DOMNode
		//		The element you wish to select the children content of.
		// nochangefocus: Boolean
		//		Indicates if the focus should change or not.
		element = dom.byId(element);
		// W3C
		var selection = win.global.getSelection();
		selection.selectAllChildren(element);
	},

	selectElement: function(/*DomNode*/ element: any, /*Boolean?*/ nochangefocus?: any){
		// summary:
		//		clear previous selection and select element (including all its children)
		// element: DOMNode
		//		The element to select.
		// nochangefocus: Boolean
		//		Boolean indicating if the focus should be changed.  IE only.
		var range;
		element = dom.byId(element);	// TODO: remove for 2.0 or sooner, spec listed above doesn't allow for string
		var doc = element.ownerDocument;
		var global = win.global;	// TODO: use winUtils.get(doc)?
		// W3C path
		var selection = global.getSelection();
		range = doc.createRange();
		if(selection.removeAllRanges){ // Mozilla
			// FIXME: does this work on Safari?
			range.selectNode(element);
			selection.removeAllRanges();
			selection.addRange(range);
		}
	},

	inSelection: function(node: any){
		// summary:
		//		This function determines if 'node' is
		//		in the current selection.
		// tags:
		//		public
		if(node){
			var newRange;
			var doc = win.doc;
			var range;

			// WC3
			var sel = win.global.getSelection();
			if(sel && sel.rangeCount > 0){
				range = sel.getRangeAt(0);
			}
			if(range && range.compareBoundaryPoints && doc.createRange){
				try{
					newRange = doc.createRange();
					newRange.setStart(node, 0);
					if(range.compareBoundaryPoints(range.START_TO_END, newRange) === 1){
						return true;
					}
				}catch(e){ /* squelch */}
			}
		}
		return false; // Boolean
	}
};


lang.setObject("dijit._editor.selection", selection);

export default selection;
